module.exports = __webpack_public_path__ + "static/img/loading.863ba823.png";